import { StateDropDown } from '@apply/components/';
import { isMobileScreen } from '@apply/ui';
import { useBrokerNewReferralStore } from '../../../state/useBrokerNewReferralStore';

interface StateIncorporatedProps {
    readOnly?: boolean;
    required?: boolean;
    onValidationEvent: (isValid: boolean) => void;
}

export const StateIncorporated: React.FC<StateIncorporatedProps> = ({
    readOnly = false,
    required = false,
    onValidationEvent,
}) => {
    const isMobile = isMobileScreen();
    const label = 'State Incorporated';
    const value = useBrokerNewReferralStore((s) => s.referral.stateIncorporated);
    const setValue = useBrokerNewReferralStore((s) => s.set_stateIncorporated);

    return (
        <>
            <StateDropDown
                id={'stateIncorporatedDropDown'}
                value={value}
                onChange={(newValue) => setValue(newValue)}
                label={label}
                required={required}
                readOnly={readOnly}
                width={isMobile ? '100%' : '230px'}
                onValidationEvent={onValidationEvent}
            />
        </>
    );
};
